import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { getConciergeSessionId, resetConciergeSessionId } from "@/components/concierge/useConciergeChat";
import { useAuth } from "@/context/AuthContext";

export const VisitorTracker = () => {
  const { pathname } = useLocation();
  const { user } = useAuth();
  useEffect(() => {
    if (user === null || pathname.startsWith("/admin") || user?.role === "admin") return;
    const track = async () => {
      const listing_key = pathname.match(/^\/listing\/([^/]+)/)?.[1];
      try {
        await api.post("/visitor/activity", { session_id: getConciergeSessionId(), path: pathname, ...(listing_key ? { listing_key } : {}) });
      } catch (error) {
        if (error?.response?.status === 404) api.post("/visitor/activity", { session_id: resetConciergeSessionId(), path: pathname, ...(listing_key ? { listing_key } : {}) }).catch(() => {});
      }
    };
    track();
  }, [pathname, user]);
  return null;
};